import { HTTPError } from 'ky';

export const getHttpExtras = async (error: HTTPError) => {
  let response: string | null = null;
  let body: string | null = null;

  // Parse response body
  try {
    if (error.response?.headers.get('Content-Type')?.includes('application/json')) {
      response = JSON.parse(await error.response.clone().text());
    } else {
      response = await error.response?.clone().text();
    }
  } catch {
    /* DO NOTHING */
  }

  // Parse request body
  try {
    if (error.request.headers.get('Content-Type') === 'application/json') {
      body = JSON.parse(await error.request.clone().text());
    } else {
      body = await error.request?.clone().text();
    }
  } catch {
    /* DO NOTHING */
  }

  const extra = {
    headers: Object.fromEntries(error.request.headers.entries()),
    method: error.request.method,
    url: error.request.url,
    message: error.message,
    response: response,
    body: body,
  };

  return extra;
};
